// extracted by mini-css-extract-plugin
export var buttonText = "klv-modal-module--buttonText--69566";